module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/eb58fc5fd9a0dfa9bcf99e2daf265792.png";